import Home from "./views/pages/user/home/Home";
import Dialogues from "./views/pages/user/dialogues/Dialogues";
import Tutorial from "./views/pages/user/tutorial/Tutorial";

import AllTopic from "./views/pages/user/glossary/AllTopic";
import Housing from "./views/pages/user/glossary/Housing";
import Legal from "./views/pages/user/glossary/Legal";
import Medical from "./views/pages/user/glossary/Medical";
import SocialSecurity from "./views/pages/user/glossary/SocialSecurity";

import HangMan from './views/pages/user/games/HangMan.jsx';
import FlipCard from './views/pages/user/games/FlipCard.jsx'
import GuessMeaning from './views/pages/user/games/GuessMeaning.jsx'
import ShuffleCard from './views/pages/user/games/ShuffleCard.jsx'
import ChangePassword from './views/pages/user/profile/ChangePassword';
import MultipleChoiceList from './views/pages/user/question-bank/MultipleChoiceList';
import MultipleChoiceExam from './views/pages/user/question-bank/MultipleChoiceExam';
import MultipleChoiceView from './views/pages/user/question-bank/MultipleChoiceView';
import MultipleChoiceHistory from './views/pages/user/question-bank/MultipleChoiceHistory';

const routes = [
  {
    path: "/home",
    name: "Home",
    icon: "ni ni-shop text-primary",
    component: Home,
    layout: "/user"
  },
  {
    path: "/dialogues",
    name: "Dialogues",
    icon: "ni ni-note-03 text-primary",
    component: Dialogues,
    layout: "/user"
  },
  {
    collapse: true,
    name: "Glossary",
    icon: "ni ni-trophy text-pink",
    state: "dashboardCollapse",
    views: [
      {
        path: "/glossary/all",
        name: "All topics",
        component: AllTopic,
        layout: "/user"
      },
      {
        path: "/glossary/medical",
        name: "Medical",
        component: Medical,
        layout: "/user"
      },
      {
        path: "/glossary/social-security",
        name: "Social Security",
        component: SocialSecurity,
        layout: "/user"
      },
      {
        path: "/glossary/legal",
        name: "Legal",
        component: Legal,
        layout: "/user"
      },
      {
        path: "/glossary/housing",
        name: "Housing",
        component: Housing,
        layout: "/user"
      }
    ]
  },
  {
    collapse: true,
    name: "Games",
    icon: "ni ni-controller text-green",
    state: "formsCollapse",
    views: [
      {
        path: "/games/shuffle-card",
        name: "Shuffle Card",
        component: ShuffleCard,
        layout: "/user"
      },
      {
        path: "/games/hang-man",
        name: "Hang Man",
        component: HangMan,
        layout: "/user"
      },
      {
        path: "/games/flip-card",
        name: "Flip Card",
        component: FlipCard,
        layout: "/user"
      },
      // {
      //   path: "/games/draggable-list",
      //   name: "Draggable List",
      //   component: Draggable,
      //   layout: "/user"
      // },
      {
        path: "/games/guess-meaning",
        name: "Guess Meaning",
        component: GuessMeaning,
        layout: "/user"
      }
    ]
  },
  {
    path: "/tutorial",
    name: "Tutorial",
    icon: "ni ni-camera-compact text-red",
    component: Tutorial,
    layout: "/user"
  },
  {
    hideSidebar: true,
    path: "/change_password",
    name: "Change password",
    icon: "ni ni-camera-compact text-red",
    component: ChangePassword,
    layout: "/user"
  },
  {
    path: "/multiple-choice/list",
    name: "Multiple Choice",
    icon: "ni ni-single-copy-04 text-info",
    component: MultipleChoiceList,
    layout: "/user"
  },
  {
    hideSidebar: true,
    path: "/multiple-choice/exam",
    name: "Multiple Choice Exam",
    icon: "ni ni-single-copy-04 text-info",
    component: MultipleChoiceExam,
    layout: "/user"
  },
  {
    hideSidebar: true,
    path: "/multiple-choice/view",
    name: "Multiple Choice View Detail",
    icon: "ni ni-single-copy-04 text-info",
    component: MultipleChoiceView,
    layout: "/user"
  },
  {
    hideSidebar: true,
    path: "/multiple-choice/history",
    name: "Multiple Choice History",
    icon: "ni ni-single-copy-04 text-info",
    component: MultipleChoiceHistory,
    layout: "/user"
  },
];

export default routes;
